import PhoneIcon from '@mui/icons-material/Phone';
import { Box, useTheme } from '@mui/material';
import React from 'react';

const PhonecallIcon = ({ boxSize, iconSize }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: boxSize || 32,
        height: boxSize || 32,
        borderRadius: '50%',
        backgroundColor: theme.palette.icon.phonecalls.background,
      }}
    >
      <PhoneIcon
        sx={{
          color: theme.palette.icon.phonecalls.contrast,
          fontSize: iconSize,
        }}
      />
    </Box>
  );
};

export default PhonecallIcon;
